import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getImmunizationRows } from "./immunization-rows";

export const metadata = {
  tableType: "Immunization",
  displayName: "Immunizations",
  getRows: (bundle: FhirBundleSdk) => getImmunizationRows({ bundle }),
};
